import _pick from 'lodash/pick';

import { multiSelect } from 'react-redux-app/lib/modules/form/utils';
import { url } from 'react-redux-app/lib/modules/routing/utils';
import { rectangleSizeToString } from '../../core/utils/rectangle';
import { getHost } from '../../app/utils/siteUrls';

import { langLangKeys } from '../../core/lang/constants';
import { LANG_ANY } from '../constants';


export const createPromotedSite = (site, wlId) => (!wlId ? site : `${site}_${wlId}`);

export const getPromotedSite = site => site?.split('_')[0];

export const getWLSiteId = site => site.split('_')[1];

export const replacePromotedSite = filter => ({ ...filter, site: getPromotedSite(filter.site) });

export const getScriptText = (launchAffiliateToolUrl, scriptQueryParams) => {
  const scriptSrc = `${launchAffiliateToolUrl}?${url.stringifyQuery(scriptQueryParams)}`;
  return (
    `<div id="${scriptQueryParams.containerId}"></div>`
    + `<script type="text/javascript" src="${scriptSrc}"></script>`
  );
};

export const getIFrameSrc = iFrameQueryParams => (
  `${getHost()}rest/webmaster/affiliate_tool/page_preview?${url.stringifyQuery(iFrameQueryParams)}`
);

export const getCustomParams = (formValues, isPromoChat) => {
  const {
    ageRange,
    backgroundColor,
    borderColor,
    borderWidth,
    columns,
    bannerLanguage,
    linkColor,
    onlineOnly,
    photoBorderColor,
    photoBorderWidth,
    profileInfoAreaWidth,
    profileInfoPosition,
    rows,
    thumbnailSize,
    showProfileInfo,
    textColor,
  } = formValues;

  const customParams = {
    ar: ageRange,
    brc: borderColor,
    bw: borderWidth,
    co: columns,
    force: 1,
    lc: linkColor,
    lng: bannerLanguage,
    ogo: onlineOnly === '1' ? 'true' : 'false',
    pbc: photoBorderColor,
    pbw: photoBorderWidth,
    piaw: profileInfoAreaWidth,
    pip: profileInfoPosition,
    promochat: isPromoChat ? '1' : '0',
    ro: rows,
    spi: showProfileInfo,
    ts: typeof thumbnailSize === 'object' ? thumbnailSize.width : thumbnailSize,
    txc: textColor,
  };

  if (backgroundColor) {
    customParams.bc = backgroundColor;
  }

  return customParams;
};

export const getSizeOptions = sizes => sizes.map(size => multiSelect.createOption(
  rectangleSizeToString(size), rectangleSizeToString(size)
));

export const getLangOptions = (langs, fm) => (!Array.isArray(langs) ? null : (
  [multiSelect.createOption(fm({ id: 'msg.lang.any' }), LANG_ANY)]
    .concat(multiSelect.getOptions(_pick(langLangKeys, langs), fm))
));

export const getColumnAndRowOptions = () => {
  const columnOptions = [];
  const rowOptions = [];

  for (let i = 1; i < 11; ++i) {
    columnOptions.push(multiSelect.createOption(i, i));
    rowOptions.push(multiSelect.createOption(i, i));
  }

  return { columnOptions, rowOptions };
};

export const getInitialSize = (sizes, size) => (
  size && sizes.some(({ width, height }) => width === size.width && height === size.height)
    ? size
    : sizes[0]
);

export const getInitialLang = (langs, lang) => (lang && langs.includes(lang) ? lang : LANG_ANY);

export const getInitialValue = (values, value) => (
  value && values.includes(value) ? value : values[0]
);
